<template>
  <v-dialog max-width="700px">
    <v-btn slot="activator" flat color="white" class="pa-4">Sign In</v-btn>
    <v-card>

      <v-card-title>
        <h2>Sign In</h2> 
      </v-card-title>

      <v-card-text>
        <v-form class="px-3">
          <v-text-field label="Email Address" ref="username" v-model="username" :rules="submitRules"></v-text-field>
          <v-text-field label="Password" :type="'password'" ref="password" v-model="password" :rules="submitRules"></v-text-field>
          <v-btn depressed large class="green lighten-3 white--text mx-auto py-4" @click="submit()">
            <span>Sign In</span>
          </v-btn>
        </v-form>
      </v-card-text>

    </v-card>
  </v-dialog>
</template>

<script>
import {bus} from '@/main.js'
import {auth} from '@/fb.js'
export default {
  name: 'NavBar',
  data() {
      return {
        username: '',
        password: '',
        submitRules: [
          value => value.length > 0 || 'Please give a input!'
        ]
      }
  },
  methods: {
      submit() {
        if(this.$refs.username.validate() && this.$refs.password.validate()) {

          auth.signInWithEmailAndPassword(this.username,this.password).then(credit => { //gives user a creditenial token
            // return dataBase.collection('users').doc(credit.user.uid).set({
            //   pins: 0
            // }); //fire store automatically creates 'users' collection and document
          })

        }
      }
  }
}
</script>
